import { render, staticRenderFns } from "./LeaderboardContainer.vue?vue&type=template&id=0bb3d598&scoped=true&"
import script from "./LeaderboardContainer.vue?vue&type=script&lang=js&"
export * from "./LeaderboardContainer.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardContainer.vue?vue&type=style&index=0&id=0bb3d598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb3d598",
  null
  
)

export default component.exports